import React from 'react'

export default function Input({ inputType, inputId, placeholder, defaultValue, classNames, disabled, ...props }) {
    return (
        <input type={inputType} id={inputId} {...(props)} placeholder={placeholder} disabled={disabled} defaultValue={defaultValue} className={`p-3 placeholder:text-[var(--dark-gray-500)] ${disabled ? "text-[#ccc]" : "text-[var(--primary)]"} text-[18px] w-full bg-[var(--light-white)] border border-[var(--periwinkle)] rounded-[10px] ${classNames}`} />
    )
}
